/* eslint-disable no-unused-vars */

import rootReducer from './root-reducer';
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist-indexeddb-storage';
import compressTransform from 'redux-persist-transform-compress';
import { createMigrate } from 'redux-persist';
import {
  FLUSH,
  PAUSE,
  PURGE,
  PERSIST,
  REGISTER,
  REHYDRATE,
  persistStore,
  persistReducer
} from 'redux-persist';

// old code
let persistConfig = {
  key: 'root',
  version: 1,
  storage: storage('my-oplii-test')
};

// if user clear cache
if (!localStorage.getItem('applicationVersion')) {
  persistConfig = {
    ...persistConfig,
    storage: storage('new-my-oplii-test'),
    serialize: false,
    deserialize: false
  };
}
// if user have old version than manually replace
else if (
  localStorage.getItem('changeDBAfterMigration') === 'true' ||
  localStorage.getItem('usedLatestDB') === 'true'
) {
  persistConfig = {
    ...persistConfig,
    storage: storage('new-my-oplii-test'),
    serialize: false,
    deserialize: false
  };
}

// persistConfig = {
//   ...persistConfig,
//   storage: storage('new-my-oplii-test'),
//   serialize: false,
//   deserialize: false
// };
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      },

      immutableCheck: false
    })
});

export const persistor = persistStore(store);
